import React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  tooltipKbdChipClassName,
} from '@/components/ui/tooltip'
import { MenuRowShortcutKbd } from '@/components/ui/shortcut-kbd'
import type { ShortcutKey } from '@/lib/keyboard/keyboard-shortcuts'

type ShortcutTooltipProps = {
  label: string
  shortcutKey: ShortcutKey
  /** Which of the shortcut's key combos the chip shows. */
  comboIndex: number
  /** The trigger element (receives the tooltip trigger props via `asChild`). */
  children: React.ReactElement
}

/** Toolbar tooltip: label plus the action's keyboard shortcut chip, shown below the trigger. */
export const ShortcutTooltip: React.FC<ShortcutTooltipProps> = ({
  label,
  shortcutKey,
  comboIndex,
  children,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="bottom">
        <span className="min-w-0 shrink">{label}</span>
        <MenuRowShortcutKbd
          shortcutKey={shortcutKey}
          comboIndex={comboIndex}
          chipClassName={tooltipKbdChipClassName}
          className="text-primary-foreground"
        />
      </TooltipContent>
    </Tooltip>
  )
}
